"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSchemaContext = void 0;
const tslib_1 = require("tslib");
const DefinitionManager_1 = require("./DefinitionManager");
const ui_1 = require("./ui");
const db_1 = require("./db");
const eval_1 = require("./eval");
const consts_1 = require("../consts");
const DataStub_1 = require("./DataStub");
const cloneDeep_1 = tslib_1.__importDefault(require("../utils/cloneDeep"));
class DataSchemaContext {
    constructor(source, opts = {}) {
        this.source = source;
        this.definitionManager = new DefinitionManager_1.DefinitionManager({ root: source });
        Object.assign(this, DataSchemaContext.defaults, opts);
    }
    /** 原始的可能有坑，例如 $ref 没解析，不要直接用！用这个处理下先 */
    patchSchema(schema) {
        if (!schema)
            return schema;
        let ans = this.definitionManager.patchSchema(schema);
        if (!ans)
            return ans;
        if (typeof ans.required === 'undefined' && this.requiredByDefault) {
            ans = Object.assign(Object.assign({}, ans), { required: true });
        }
        return ans;
    }
    makeRootStubOf(data) {
        return DataStub_1.DataStub.fromRoot(this, data);
    }
    /**
     * 获取一个Schema，默认返回 root Schema
     *
     * @param ref — 例如 `#`、`#/definitions/foobar` 以及 `#/fields/foobar` 等
     */
    getSchema(ref) {
        const base = this.definitionManager.getDefinition(ref || '#');
        return this.definitionManager.patchSchema(base);
    }
    getUIConfig(schema) {
        var _a;
        if ((_a = schema.ui) === null || _a === void 0 ? void 0 : _a.type)
            return schema.ui;
        for (let i = 0; i < this.uiResolvers.length; i++) {
            const answer = this.uiResolvers[i](schema);
            if (answer)
                return answer;
        }
        return (0, ui_1.getDefaultUIConfig)(schema);
    }
    getDBConfig(schema, db = this.db) {
        return (0, db_1.getDBConfig)(schema, db);
    }
    /**
     * （在 schema.default 没设置时使用）根据 schema 自动生成默认值
     *
     * @internal 不要直接使用这个！请使用 DataStub 里的 `getDefaultValue(opts?)`
     */
    getDefaultValue(evalCtx, opts = this.defaults) {
        var _a, _b, _c, _d, _e;
        const { schema } = evalCtx;
        const { ignoreExample } = opts;
        const { evalExtraCtx } = this;
        if (schema.default !== undefined)
            return (0, eval_1.processMaybeEval)(schema.default, evalCtx, evalExtraCtx);
        if ((_a = schema.enum) === null || _a === void 0 ? void 0 : _a.length)
            return (0, cloneDeep_1.default)(schema.enum[0].value);
        if (!ignoreExample) {
            if (typeof schema.example !== 'undefined')
                return (0, cloneDeep_1.default)(schema.example);
            if ((_b = schema.examples) === null || _b === void 0 ? void 0 : _b.length)
                return (0, cloneDeep_1.default)(schema.examples[0].value);
        }
        if (schema.type === 'object') {
            const { optionalProperties = 'default' } = opts;
            const ans = {};
            const ansEvalCtx = { schema, value: ans, parent: evalCtx };
            const removedGroupIds = schema.groups
                ? schema.groups
                    .filter(x => x.condition && !(0, eval_1.tryEvalExpr)(x.condition, false, ansEvalCtx, evalExtraCtx))
                    .map(x => x.id)
                : [];
            (_c = schema.fields) === null || _c === void 0 ? void 0 : _c.forEach(fieldRaw => {
                var _a;
                const fieldSchema = this.patchSchema(fieldRaw);
                if (!fieldSchema.id)
                    return;
                if (fieldSchema.group && removedGroupIds.includes(fieldSchema.group))
                    return;
                if (fieldSchema.condition && !(0, eval_1.tryEvalExpr)(fieldSchema.condition, false, ansEvalCtx, evalExtraCtx))
                    return;
                if (!fieldSchema.required) {
                    if (optionalProperties === 'never')
                        return;
                    if (optionalProperties === 'default' && !('default' in fieldSchema || ((_a = fieldSchema.enum) === null || _a === void 0 ? void 0 : _a.length)))
                        return;
                }
                const fieldValue = this.getDefaultValue({
                    root: evalCtx.root,
                    schema: fieldSchema,
                    parent: Object.assign(Object.assign({}, evalCtx), { value: ans })
                }, Object.assign(Object.assign({}, opts), { ignoreExample: optionalProperties === 'default' }));
                if (fieldValue !== undefined) {
                    ans[fieldSchema.id] = fieldValue;
                }
            });
            return ans;
        }
        return (_e = (_d = consts_1.typeDefaults[schema.type]) === null || _d === void 0 ? void 0 : _d.call(consts_1.typeDefaults)) !== null && _e !== void 0 ? _e : null; // FIXME: 应对未知的 type
    }
}
exports.DataSchemaContext = DataSchemaContext;
/** DataSchemaContextOpts 默认值 */
DataSchemaContext.defaults = {
    db: { family: "mysql" },
    requiredByDefault: false,
    autoCompleteMissingFields: false,
    defaults: {},
    immutable: true,
    setter: (obj, key, value) => { obj[key] = value; },
    uiResolvers: [],
    evalExtraCtx: null,
};
//# sourceMappingURL=DataSchemaContext.js.map